import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Label,
  ChipList,
  Chip,
  ChipText,
  RemoveIcon,
  ClearButton,
  VehicleChip,
  VehicleChipIcon,
  VehicleChipInfo,
  VehicleChipTitle,
  VehicleChipDetails,
  VehicleChipCount,
} from './RecentSearchesSection.styled';

const RecentSearchesSection = ({
  searches,
  onSelectSearch,
  onRemoveSearch,
  onClearAll,
}) => {
  const { t } = useTranslation();
  
  // Filter out old raw EAN strings (strings containing ||) - they're not user friendly
  const filteredSearches = searches.filter((search) => {
    if (typeof search === 'string' && search.includes('||')) {
      return false; // Skip old raw EAN strings
    }
    return true;
  });

  if (!filteredSearches || filteredSearches.length === 0) return null;

  const renderSearch = (search, index) => {
    // Vehicle search object
    if (typeof search === 'object' && search.type === 'vehicle') {
      const { vehicleInfo } = search;
      return (
        <VehicleChip
          key={index}
          onClick={() => onSelectSearch(search)}
        >
          <VehicleChipIcon>
            <i className="mdi mdi-car" />
          </VehicleChipIcon>
          <VehicleChipInfo>
            <VehicleChipTitle>
              {vehicleInfo.vendor} {vehicleInfo.model}
            </VehicleChipTitle>
            <VehicleChipDetails>
              {vehicleInfo.year} • {vehicleInfo.fitment}
            </VehicleChipDetails>
          </VehicleChipInfo>
          <VehicleChipCount>
            {vehicleInfo.eanCount}
          </VehicleChipCount>
          <RemoveIcon
            className="mdi mdi-close-circle"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveSearch(search);
            }}
          />
        </VehicleChip>
      );
    }

    // Plain text search
    return (
      <Chip
        key={index}
        onClick={() => onSelectSearch(search)}
      >
        <ChipText>{search}</ChipText>
        <RemoveIcon
          className="mdi mdi-close-circle"
          onClick={(e) => {
            e.stopPropagation();
            onRemoveSearch(search);
          }}
        />
      </Chip>
    );
  };

  return (
    <Container>
      <Label>
        <i className="mdi mdi-history" />
        {t('recentSearches')}
      </Label>
      <ChipList>
        {filteredSearches.map((search, index) => renderSearch(search, index))}
      </ChipList>
      <ClearButton onClick={onClearAll}>
        {t('clearAll')}
      </ClearButton>
    </Container>
  );
};

RecentSearchesSection.propTypes = {
  searches: PropTypes.array.isRequired,
  onSelectSearch: PropTypes.func.isRequired,
  onRemoveSearch: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default RecentSearchesSection;

